import { render, staticRenderFns } from "./WhatsNewSidebar.vue?vue&type=template&id=74006c1e&scoped=true"
import script from "./WhatsNewSidebar.vue?vue&type=script&lang=js"
export * from "./WhatsNewSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74006c1e",
  null
  
)

export default component.exports